export const SESSION_COOKIE = 'idsrv.session';
export const INCOMPATIBLE_BROWSER_COOKIE = 'incompatible-browser';
